import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import {
  FETCH_REFERENCE_DATA_REQUEST,
  fetchAllReferenceDataSuccess,
  fetchAllReferenceDataFail,
} from "../actions/actions_reference";
import util from "../../utils/Helpers";

import "isomorphic-fetch";
import { polyfill } from "es6-promise";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:3214"
  : `${util.getCurrentHost()}/auth/auth`;

const fetchReferenceDataEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_REFERENCE_DATA_REQUEST),
    mergeMap((action) =>
      fetch(`${apiIndex}/reference/externalData`, {
        credentials: "include",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Basic " +
            window.btoa(
              "flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"
            ),
        },
      })
        .then((response) => response.json())
        .then((data) => fetchAllReferenceDataSuccess(data))
        .catch((error) => fetchAllReferenceDataFail(error))
    )
  );

export default fetchReferenceDataEpic;
